import Button from "../../components/Button/Button";
import stylesSign from "../../shared-styles/Sign.module.css";
import stylesInput from "../../components/Input/Input.module.css";
import stylesReset from "./forgetPassword.module.css";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schema from "../../utils/validations/ForgetPassword/index";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { forgetPassword as forgetPasswordDispatch } from "../../store/auth/forgetPasswordThunk";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

export default function ForgetPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors, isLoading, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const { forgotPasswordLoading } = useSelector(
    (state: RootState) => state.auth.forgotPassword
  );

  async function onSubmit(data: { email: string }) {
    const resultAction = await dispatch(forgetPasswordDispatch(data));

    if (forgetPasswordDispatch.rejected.match(resultAction)) {
      toast.error(resultAction?.payload?.message || "Something went wrong");
    } else {
      toast.success("Check your email for password reset link");
      const timeOut = setTimeout(() => {
        clearTimeout(timeOut);
        navigate("/sign-in");
      });
    }
  }

  return (
    <main className={stylesSign.main}>
      <form onSubmit={handleSubmit(onSubmit)} className={stylesSign.form}>
        <h1>Forget Password</h1>
        <p className={stylesReset.subtitle}>
          Enter your email address and we'll send you a link to reset your
          password.
        </p>
        <div className={stylesSign.box}>
          <label className={stylesInput.label}>Email</label>
          <input
            type="email"
            placeholder="Email Address"
            className={stylesInput.input}
            {...register("email")}
          />
          {errors.email && (
            <p className={stylesInput.error}>
              {errors.email.message || "Something went wrong"}
            </p>
          )}
        </div>
        <Button
          type="submit"
          className="primary"
          disabled={isLoading || isSubmitting || forgotPasswordLoading}
        >
          {isLoading || isSubmitting || forgotPasswordLoading
            ? "Loading..."
            : "Send Reset Link"}
        </Button>
      </form>
    </main>
  );
}
